import React from "react";
import { alpha, Grid, Typography } from "@mui/material";
import { BIGroupingHeader } from '../../@signals'
import { dsColorNew } from "@palette"

export default function officeHeader() {

    return {
        name: 'columnName',
        setHeaderCellProps: () => ({
            sx:{
                backgroundColor: dsColorNew.tableHead,
                position: 'sticky',
                top: 0,
                left: 0,
                zIndex: '160 !important',
                border: 0,
                verticalAlign: 'middle',
            }}),
        render: () => <Grid container sx={{ minWidth: 220 }}>
            <Grid item xs={12}>
                <Typography sx={{ textAlign: 'left', textTransform: 'none', fontWeight: 500, fontSize: 12.5, color: alpha(dsColorNew.white, 0.72) }}>{BIGroupingHeader.value}</Typography>
            </Grid>
        </Grid>
    }
}